import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

const passwordValidation =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/

export const passwordResetVerifyFormSchema = z
  .object({
    confirmPassword: z.string().min(1),
    email: z.string().min(1).email(),
    password: z.string().min(1).regex(passwordValidation, {
      message: FORM_MESSAGES_MAP.PASSWORD,
    }),
    token: z.string().min(1),
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: 'custom',
        message: FORM_MESSAGES_MAP.CONFIRM_PASSWORD,
        path: ['confirmPassword'],
      })
    }
  })
